export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/bg-mask.a2e7d72b.svg","height":297,"width":1229};